import { useState } from "react";

/**
 * Emulates the use of a Set, add methods to output as needed
 * @param initialSet
 */
export default function useSet<T = any>(initialSet = undefined) {
  const [set, replaceSet] = useState<Set<T>>(initialSet || new Set<T>());

  return {
    has: (value: T) => set.has(value),
    add: (value: T) => {
      replaceSet(current => {
        const newSet = new Set(current);
        newSet.add(value);
        return newSet;
      });
    },
    delete: (value: T) => {
      replaceSet(current => {
        const newSet = new Set(current);
        newSet.delete(value);
        return newSet;
      });
    },
  };
}



// WEBPACK FOOTER //
// ./app/javascript/components/hooks/useSet.ts